export { memoryStorage } from '@apparel/core/storage';
